import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  CmsContentDirective,
  CmsFooterComponent,
  CmsHeaderComponent,
} from '@domgen/dgx-fe-cms';
import { Image } from '@domgen/dgx-fe-components/media';
import { ModalContainerComponent } from '@domgen/dgx-fe-components/modal';
import { NotificationsComponent } from '@domgen/dgx-fe-notifications';
import { AppComponentService } from '../../services/app-component/app-component.service';

@Component({
  selector: 'us-sidedoor-reg-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  providers: [AppComponentService],
  imports: [
    AsyncPipe,
    CmsContentDirective,
    CmsFooterComponent,
    CmsHeaderComponent,
    ModalContainerComponent,
    NgClass,
    NgIf,
    NotificationsComponent,
    RouterOutlet,
  ],
})
export class AppComponent {
  constructor(readonly cs: AppComponentService) {}

  navigationLink = { href: window.location.origin };

  partnerLogo: Image = {
    alt: 'Powered By D&G logo',
    aspectRatio: '16:9',
    src: 'assets/images/powered-by-domestic-and-general.svg',
  };
}
